import "./App.css";
import URI from "./constants/URI";
import CssBaseline from "@mui/material/CssBaseline";
import { Route, Routes } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import SignupForm from "./components/SignupForm";
import HomePage from "./containers/HomePage";
import TopBar from "./components/TopBar";
import Test from "./containers/Test";
import QuizPage from "./containers/QuizPage";
import { createTheme, Fab, ThemeProvider, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import PreferencesPage from "./containers/PreferencesPage";
import ReviewPage from "./containers/ReviewPage";
import ScoreboardPage from "./containers/ScoreboardPage";
import ContactPage from "./containers/ContactPage";
import axios from "axios";
import LANGUAGES from "./constants/Languages";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import ScrollTop from "./components/ScrollTop";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function App() {
  // Pass this down to children so when the language is changed they can call the API to fetch the translation
  const [langChanged, setLangChanged] = useState(false);

  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const { i18n } = useTranslation();

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: prefersDarkMode ? "dark" : "light",
        },
      }),
    [prefersDarkMode]
  );

  const currentLangCode =
    window.localStorage.getItem("i18nextLng") ||
    cookies.get("i18next") ||
    LANGUAGES[0].code;
  const currentLang = LANGUAGES.find((l) => l.code === currentLangCode);

  useEffect(() => {
    document.body.dir = currentLang.dir;
    setLangChanged((langChanged) => !langChanged);
  }, [currentLang]);

  const changeLang = (event) => {
    const code = event.target.value;
    i18n.changeLanguage(code);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TopBar currentLang={currentLang} changeLang={changeLang} />
      {getRoutes(langChanged)}
      <ScrollTop>
        <Fab size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </ThemeProvider>
  );
}

const getRoutes = (langChanged) => {
  return getPublicRoutes(langChanged);
};

const getPublicRoutes = (langChanged) => {
  return (
    <Routes>
      <Route path={URI.HOME} element={<HomePage />} />
      <Route path={URI.LOGIN} element={<LoginForm />} />
      <Route path={URI.SIGNUP} element={<SignupForm />} />
      <Route path={URI.QUIZ} element={<QuizPage langChanged={langChanged} />} />
      <Route
        path={URI.PREFERENCES}
        element={<PreferencesPage langChanged={langChanged} />}
      />
      <Route path={URI.SCOREBOARD} element={<ScoreboardPage />} />
      <Route path={URI.REVIEW} element={<ReviewPage />} />
      <Route path={URI.CONTACT} element={<ContactPage />} />
      <Route path={URI.TEST} element={<Test />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
};

(function () {
  let token = window.localStorage.getItem("token");
  axios.defaults.headers.common["Authorization"] = token || null;
})();

export default App;
